<template>
  <div class="benchmarks-message">
    <div class="icon">
      <AlertIcon v-if="shouldBlurValues" fill="#FEB631" id="benchmarks-icon"/>
      <AddIcon v-else-if="brandError" id="benchmarks-icon"/>
      <ChartErrorIcon v-else id="benchmarks-icon"/>
    </div>
    <h1 class="heading">
      {{heading}}
    </h1>
    <div class="body">
      <div v-if="brandError" class="message-button">
        <PrimaryButton @click="$emit('add')">
          Select brand
        </PrimaryButton>
      </div>
      <div
        v-else-if="noCategorySelected && !isOptOutFromCategoryBenchmarksError"
        class="message-button"
      >
        <PrimaryButton @click="$emit('add')">
          Select Category
        </PrimaryButton>
      </div>
      <div v-else>
          {{body}}
          <div v-if="emphasisedMessage" class="message-emphasis">
            Tip: Select a wider date range for your brand to see a larger data set.
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  AlertIcon,
  AddIcon,
  PrimaryButton,
} from '@mikmak/components';
import ChartErrorIcon from './Icons/ChartErrorIcon.vue';

export default {
  props: {
    shouldBlurValues: {
      type: Boolean,
      default: false,
    },
    dataError: {
      type: Boolean,
      default: false,
    },
    brandError: {
      type: Boolean,
      default: false,
    },
    categoryError: {
      type: Boolean,
      default: false,
    },
    category: {
      type: String,
      default: '',
    },
    title: {
      type: String,
    },
    isOptOutFromCategoryBenchmarksError: {
      type: Boolean,
      default: false,
    },
    noCategorySelected: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AlertIcon,
    AddIcon,
    PrimaryButton,
    ChartErrorIcon,
  },
  computed: {
    heading() {
      switch (true) {
        case this.shouldBlurValues:
          return 'Not Enough Data';
        case this.brandError:
          return 'Please select a single brand from the filters to view benchmarks';
        case this.isOptOutFromCategoryBenchmarksError:
          return 'Your brand has opted out of Category Benchmarks';
        case this.noCategorySelected:
          return 'You do not have a selected category for your brand. Please select a category to show data in the charts.';
        default:
          return 'No Data';
      }
    },
    body() {
      const bodyText = 'To ensure the insights you view are actionable, ' +
        'MikMak maintains a minimum threshold of activity required for data ' +
        'to be statistically significant. ';

      switch (true) {
        case this.categoryError:
          return bodyText + `The category, ${this.category}, doesn’t meet the ` +
                 'threshold at this time. We are working to add more brands to your category.';
        case this.shouldBlurValues:
          return bodyText + 'This benchmark doesn’t meet the threshold at this time.';
        case this.dataError:
          return `No data available for ${this.title}`;
        case this.isOptOutFromCategoryBenchmarksError:
          return 'Please contact your Customer Success Manager for additional information.';
        default:
          return '';
      }
    },
    emphasisedMessage() {
      return this.shouldBlurValues && !this.categoryError && !this.dataError && !this.brandError;
    },
  },
};
</script>

<style>

</style>

<style scoped>

.benchmarks-message #benchmarks-icon {
  width: 40px;
  height: 40px;
}

.benchmarks-message {
  height: auto;
  width: 725px;
  position: absolute;
  top: 95px;
  left: 50%;
  transform: translateX(-50%);
  line-height: 140%;
  font-size: 16px;
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  text-align: center;
  color: #778699;
}

.heading {
  font-size: 24px;
  font-weight: 400;
  color: #223448;
  padding: 8px;
}

.message-emphasis {
  font-style: italic;
  padding: 16px;
}

.message-button {
  padding: 8px 0;
}
</style>
